import React from 'react';
import styled from 'src/ui/library/styled';
// import PropTypes from 'prop-types';
import CloseIcon from '../../../assets/dashboardIcons/CloseIconBlack.png';

const styles = () => ({
  badge: {
    // width: 'max-content',
    paddingRight: '10px',
    // whiteSpace: 'nowrap',
    // display: 'flex',
    borderRadius: '20px',
    padding: '4px 10px',
    border: '1px solid #2e2e38',
    display: 'inline-block',
    width: 'fit-content',
    marginRight: '10px',
    marginTop: '10px',
    '@global': {
      // div: {
      //   '&:nth-child(1)': {
      //     display: 'flex',
      //     borderRadius: '20px',
      //     padding: '4px 10px',
      //     border: '1px solid #2e2e38',
      //   },
      // },
      span: {
        '&:nth-child(1)': {
          paddingRight: '4px',
          width: '100%',
        },
        '&:nth-child(2)': {
          paddingRight: '14px',
          width: '100%',
        },
      },
    },
  },
});

const BadgeWithCloseButton = ({ classes, labelLeft, labelRight, displayText, onClickTest }) => {
  return (
    <span className={classes.badge}>
      <span>{displayText ? displayText : labelLeft}:</span>
      <span>{labelRight}</span>
      <span className="cursor-pointer">
        <img src={CloseIcon} alt="Close" onClick={() => onClickTest(labelLeft)} />
      </span>
    </span>
  );
};

// BadgeWithCloseButton.propTypes = {
//   labelLeft: PropTypes.string.isRequired,
//   labelRight: PropTypes.string.isRequired,
//   onClickTest: PropTypes.func,
// };

export default styled(BadgeWithCloseButton)(styles);
